var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 153,
    viewBox: "0 0 457 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 188.5,
    y: 48,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#24B14B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10768_14498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.5 108C217.454 108 208.5 99.046 208.5 88C208.5 76.954 217.454 68 228.5 68C239.546 68 248.5 76.954 248.5 88C248.5 99.046 239.546 108 228.5 108ZM228.5 104C232.743 104 236.813 102.314 239.814 99.3137C242.814 96.3131 244.5 92.2435 244.5 88C244.5 83.7565 242.814 79.6869 239.814 76.6863C236.813 73.6857 232.743 72 228.5 72C224.257 72 220.187 73.6857 217.186 76.6863C214.186 79.6869 212.5 83.7565 212.5 88C212.5 92.2435 214.186 96.3131 217.186 99.3137C220.187 102.314 224.257 104 228.5 104ZM226.506 96L218.02 87.514L220.848 84.686L226.506 90.344L237.818 79.03L240.648 81.858L226.506 96Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10768_14498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(204.5 64)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportSuccess);
export default __webpack_public_path__ + "static/media/ExportSuccess.bdd465e8be8375510606ac72f3edfc0b.svg";
export { ForwardRef as ReactComponent };